import { IShareWorksItem } from '@/schemas/doctor';

interface IState {
  editVideoId: string;
  editVideoTitle: string;
  selectedDiseaseVideo: IShareWorksItem;
}

const mainMessage = {
  state: {
    editVideoId: '',
    editVideoTitle: '',
    selectedDiseaseVideo: {
      caption: '',
      coverUrl: '',
      height: -1,
      ksUrl: '',
      likeCount: -1,
      photoId: '',
      poi: {
        address: '',
        category: '',
        city: '',
        id: -1,
        tittle: ''
      },
      timeMillis: -1,
      userHeaderUrl: '',
      userId: -1,
      userName: '',
      viewCount: -1,
      width: -1
    } as IShareWorksItem
  } as IState,

  reducers: {
    updateState(state, payload) {
      const result = {
        ...state,
        ...payload
      };
      return result;
    }
  },

  effects: (_dispath) => ({})
};

export default mainMessage;
